// src/components/TimeGridSelector.js
import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Clock } from 'lucide-react';

function TimeGridSelector({ availableTimes, selectedTime, onTimeSelect, selectedDate }) {
    
    if (!selectedDate) {
        return (
            <div className="h-full flex flex-col items-center justify-center p-8 text-center bg-[#FFF5EE]/30 rounded-2xl border border-dashed border-[#dbcdac]/60">
                <Clock className="w-10 h-10 text-[#dbcdac] mb-3 opacity-50" />
                <p className="font-serif text-lg text-[#528a89]">Selecione uma data</p>
                <p className="text-sm text-stone-400 font-light mt-1">Para visualizar os horários disponíveis no nosso local.</p>
            </div>
        );
    }

    if (availableTimes.length === 0) {
        return (
            <div className="h-full flex flex-col items-center justify-center p-8 text-center bg-[#971253]/5 rounded-2xl border border-[#971253]/20">
                <p className="font-serif text-lg text-[#971253]">Salão Lotado</p>
                <p className="text-sm text-stone-500 font-light mt-1">Não há mais mesas disponíveis para este dia. Tente outra data!</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full">
            <div className="mb-4">
                <h4 className="font-serif text-lg text-[#528a89] mb-1">
                    Horários para {format(selectedDate, "EEEE, dd 'de' MMMM", { locale: ptBR })}
                </h4>
                <p className="text-xs text-stone-500 uppercase tracking-widest">Escolha a hora de chegada</p>
            </div>

            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-3 animate-in fade-in duration-500">
                {availableTimes.map((timeObj, index) => {
                    // Checa se este botão é o horário selecionado
                    const isSelected = selectedTime && timeObj.getTime() === selectedTime.getTime();
                    const timeString = format(timeObj, 'HH:mm');

                    return (
                        <button
                            key={index}
                            type="button"
                            onClick={() => onTimeSelect(timeObj)}
                            className={`
                                py-3 rounded-xl text-sm font-bold tracking-wider transition-all duration-300
                                ${isSelected 
                                    ? 'bg-[#528a89] text-[#FFF5EE] shadow-md transform scale-105 border-transparent' 
                                    : 'bg-white text-stone-600 border border-[#dbcdac]/50 hover:border-[#528a89] hover:text-[#528a89] shadow-sm'
                                }
                            `}
                        >
                            {timeString}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default TimeGridSelector;